import React from 'react';
import { defineMessages, T, t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { List } from '@wds/list';
import { Responsive } from '@wds/responsive';
import { NavButton } from '../nav-button';

const COPY = defineMessages({
  FAQ: {
    id: 'FAQ.faq',
    defaultMessage: 'FAQ',
    description: '[Type: Label][Vis.: low] - FAQ link in main navigation',
  },
});

const FAQ = () => {
  const url = createURL('/faq/', { ut_source: 'header' });
  const title = t(COPY.FAQ);

  return (
    <>
      <Responsive minWidth="xl">
        {matches =>
          matches ? (
            <li>
              <NavButton href={url} label={title}>
                <T desc={COPY.FAQ} />
              </NavButton>
            </li>
          ) : (
            <List.Item isNavigable href={url}>
              <T desc={COPY.FAQ} />
            </List.Item>
          )
        }
      </Responsive>
    </>
  );
};

export default FAQ;
export { FAQ };
